module.exports = __webpack_public_path__ + "static/media/banner_representantes.9ebc9512.png";